import { BaseModel } from './base.model';
import { CompetenceModel } from './competence.model';
import { Deserializable } from './deserializable';

export class BehavioranchorModel extends BaseModel implements Deserializable {

  // columns
  content: string;
  expression_positive: string;
  expression_negative: string;
  competence_id: number; // tslint:disable-line: variable-name

  // client
  value: number;

  // relations
  competence: CompetenceModel = null;

  deserialize(input: any, loadCompetence = true): this {
    Object.assign(this, input);
    if (loadCompetence === true && this.competence !== null && this.competence !== undefined) {
      this.competence = new CompetenceModel().deserialize(this.competence);
    }
    this.loaded = true;
    return this;
  }

}
